import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import vbclass from "vue-body-class";
import "./class-component-hooks";
import { FETCH_CURRENT_PAGE, FETCH_SETTING_DATA } from "./store/actions.names";
import VueAwesomeSwiper from "vue-awesome-swiper";
import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import "swiper/dist/css/swiper.css";
import "animate.css";
import VueScrollmagic from "vue-scrollmagic";
import AOS from "aos";
import "aos/dist/aos.css";
import VuePlyr from "vue-plyr";
import VueYoutube from "vue-youtube";
// import { Tabs, Tab } from "vue-tabs-component";
import * as VueGoogleMaps from "vue2-google-maps";
import "vue-plyr/dist/vue-plyr.css";
import "./vee-validate";
import "vue-select/dist/vue-select.css";
import "./class-hooks";
import { PreviewParams } from "./types";

Vue.use(require("vue-moment"));

// Vue.component("tabs", Tabs);
// Vue.component("tab", Tab);
Vue.use(VuePlyr);
Vue.use(VueVideoPlayer);
Vue.use(VueScrollmagic);
Vue.use(VueAwesomeSwiper);
Vue.use(VueYoutube);
Vue.use(vbclass, router);

// Vue.component('ValidationProvider', ValidationProvider);

//Vue.use(SmoothScroll)

Vue.config.productionTip = false;
//  store.dispatch(FETCH_SETTING_DATA);
store.dispatch(FETCH_SETTING_DATA).then(() => {
  // console.log("maploaded");
  Vue.use(VueGoogleMaps, {
    load: {
      key: store.getters.mapAPIKey
    },
    installComponents: true
  });
});
const isProd =
  process.env.NODE_ENV === "production" &&
  process.env.VUE_APP_DEVENV === "production";
router.beforeEach((to: any, from: any, next: any) => {
  let params: string | PreviewParams;
  if (to.query.token) {
    params = to.query;
  } else {
    params = to.path;
  }
  store.dispatch(FETCH_CURRENT_PAGE, params).then(() => {
    next();
  });
});

new Vue({
  created() {
    AOS.init({
      disable: "phone",
      once: true
    });
  },
  router,
  store,
  render: h => h(App)
}).$mount("#app");
